//整數
const IntegerRegex = /(^-?[1-9]\d*)|(0{1})$/;

//信箱
const EmailRegex = [
  (v) => !!v || "請輸入Email",
  (v) => /.+@.+/.test(v) || "請輸入正確格式",
];

//密碼
const PasswordRegex = [
  (v) =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*.~_-]{8,}$/.test(v) ||
    "1. 至少 8 個字元  2. 有大小寫字母  3.至少一個數字",
];

const NullRegex = [(v) => !!v || " "];

export default {
  IntegerRegex: IntegerRegex,
  EmailRegex: EmailRegex,
  NullRegex: NullRegex,
  PasswordRegex: PasswordRegex,
};
